/****************
 * STUCK ON A SCREEN: THE ORB OFFERS A HAND. 2026-10-25, Guillaume: "Stuck on a
 * screen -> Orb propose assistance."
 *
 * A person who stays on one of the screens where something gets done (pick a
 * trader, start a copy, connect an exchange, read their sessions, Get Started)
 * for STUCK_AFTER_MS without moving on is offered help: the Orb rings with a
 * line about that screen and a Show me. Once a day per screen (the live
 * message's own cooldown); never while a welcome guide is on screen.
 *
 * Pure, so a test drives it. Twin: frontend/src/lib and mobile-app/src/lib.
 ****************/

export const STUCK_AFTER_MS = 2 * 60 * 1000;

export interface StuckOffer {
  /** The screen's name: the trigger ("stuck-<screen>") and the text keys (orb.live.stuck.<screen>.*). */
  screen: 'traders' | 'copyTrade' | 'sessions' | 'getStarted' | 'brokerKeys';
  /** A Show me guide (orbGuides), when one walks the screen. */
  guide?: string;
}

/** The offer for a path (web or phone route), or null for a screen that gets none. */
export function stuckOfferFor(path: string): StuckOffer | null {
  const p = path.replace(/^\/m(?=\/|$)/, '').replace(/^\/\(tabs\)/, '').replace(/\/+$/, '') || '/';
  if (p === '/traders') return { screen: 'traders', guide: 'find-a-trader' };
  if (p === '/copy-trade') return { screen: 'copyTrade', guide: 'start-session' };
  if (p === '/sessions') return { screen: 'sessions', guide: 'adjust-rules' };
  if (p === '/get-started') return { screen: 'getStarted', guide: 'first-steps' };
  if (p === '/broker-keys') return { screen: 'brokerKeys', guide: 'connect-exchange' };
  return null;
}
